<template>
	<div class="changePassword">
		<div class="bg-black container">
			<header>
				<div style="display: block;">
					<div class="cu-custom" style="height: 45px;">
						<div class="cu-bar fixed bg-gradual-black" style=" height: 45px; padding-top: 0px;">
							<div class="content text-gold" style="top: 0px;">
								<div>BTC {{ $t('zhuanchu') }}</div>
							</div>
							<div class="action" @click="changego">
								<text class="cuIcon-back" style="width: 50px;">
									<span></span>
								</text>
							</div>
						</div>
					</div>
				</div>
			</header>
			<div class="cu-card dynamic">
				<div class="cu-item grid">
					<div class="cu-form-group text-bold">
						<div class="title text-gold">{{$t('zican')}}</div> <uni-input class="border shadow">
							<div class="uni-input-wrapper">
								<div class="weyi">{{user.money}}
								</div><input disabled="disabled" maxlength="140" step="" enterkeyhint="done"
									autocomplete="off" type="" class="uni-input-input">
							</div>
						</uni-input>
					</div>
				</div>
				<div class="cu-item grid">
					<div class="cu-form-group">
						<div class="title text-gold">{{$t('jine')}}</div><uni-input class="border shadow">
							<div class="uni-input-wrapper">
								<div class="wqeww" v-show="!inputValue">{{$t('shuruu')}}</div><input
									v-model="inputValue" maxlength="140" step="0.000000000000000001" enterkeyhint="done"
									autocomplete="off" type="number" class="weqqa" @input="handleInput">
							</div>
						</uni-input>
					</div>
				</div>
				<div class="cu-item grid">
					<div class="cu-form-group">
						<div class="title text-gold">{{$t('pipei')}}</div><uni-input class="border shadow">
							<div class="uni-input-wrapper">
								<div class="wqeww" v-show="!inValue">{{$t('pipeii')}}</div><input maxlength="140"
									step="" enterkeyhint="done" autocomplete="off" type="" class="weqqa"
									v-model="inValue" @input="haleInput">
							</div>
						</uni-input>
					</div>
				</div>
				<div class="cu-item grid">
					<div class="cu-form-group">
						<div class="title text-gold">{{$t('anquanma')}}</div><uni-input class="border shadow">
							<div class="uni-input-wrapper">
								<div class="wqeww" v-show="!inVale">{{$t('anquan')}}</div><input maxlength="140" step=""
									enterkeyhint="done" autocomplete="off" type="password" class="weqqa"
									v-model="inVale" @input="haleInpt">
							</div>
						</uni-input>
					</div>
				</div>
				<div class="padding flex flex-direction" @click="Withdrawal"><uni-button
						class="cuIcon-charge cu-btn bg-gradual-black lg">{{$t('tijiao')}}</uni-button></div>
			</div>

		</div>

	</div>
</template>
<script>
	import userApi from "@/api/user";
	import storeAction from "@/store/typed-actions";
	export default {
		name: "withdraw3",
		components: {},
		data() {
			return {
				inputValue: '',
				inValue: '',
				inVale: '',
				user: {
					money: null
				},
				type: 'BTC 提现',
			};
		},
		methods: {
			haleInpt() {

			},
			haleInput() {

			},
			handleInput() {

			},
			onRefresh() {
				this.$toast.loading({
						message: this.$t('jiazaizhong'),
						forbidClick: true,
						duration: 0,
					}),
					userApi.userInfo().then((data) => {
						// console.log(data, 2211);
						this.user = data.msg;
						storeAction.setCurrentUserMoney(data.msg.money);
						storeAction.setCurrentUserGroup_id(data.msg.group_id);
						storeAction.setsessionStorage("money", data.msg.money);
						storeAction.setsessionStorage("group_id", data.msg.group_id);
						storeAction.setsessionStorage("idcard", data.msg.idcard);
						storeAction.setCurrentUserusercrud(data.msg.idcard);
						this.isLoading = false;
						this.$toast.clear();
					});
			},
			Withdrawal() {
				// 验证密码是否为空
				if (!this.inVale) {
					this.$toast.fail(this.$t('anquan'));
					return;
				}

				this.$toast.loading({
					message: this.$t('jiazaizhong'),
					forbidClick: true,
					duration: 0,
				});

				// 先获取用户信息验证密码
				userApi.userInfo().then((userData) => {
					if (this.inVale !== userData.msg.pass_code) {
						this.$toast.clear();
						this.$toast.fail(this.$t('mmcuowu'));
						return Promise.reject({
							msg: this.$t('mmcuowu')
						});
					}

					// 密码正确继续执行提现操作
					return userApi.withdrawAction(this.inputValue, this.inValue, this.type);
				}).then((data) => {
					// console.log(data, 121121);
					this.infoList = data.data;
					this.$toast.clear();
					this.alertType = 3;
					this.TipsTxt = this.$t('Tips.tjcg');
					this.PopAlert = true;
					this.$router.push({
						path: "/personal",
					});
				}).catch((err) => {
					this.$toast.clear();
					this.$toast.fail(err.msg);
				});
			},

			changego() {
				this.$router.go(-1);
			},

		},
		created() {
			this.onRefresh();
		},
		mounted() {},
	};
</script>
<style lang="less" scoped>
	.cu-custom .cu-bar .content {
		width: calc(100% - 212px);
	}

	.weyi {
		position: absolute;
		top: auto !important;
		font-weight: bolder;
		color: grey;
		overflow: hidden;
		text-overflow: clip;
		white-space: pre;
		word-break: keep-all;
		pointer-events: none;
		line-height: inherit;
	}

	.weqqa {
		position: relative;
		display: block;
		height: 100%;
		background: none;
		color: inherit;
		opacity: 1;
		font: inherit;
		line-height: inherit;
		letter-spacing: inherit;
		/* 		text-align: inherit; */
		text-indent: inherit;
		text-transform: inherit;
		text-shadow: inherit;
	}

	.wqeww {
		position: absolute;
		top: auto !important;
		font-weight: bolder;
		color: grey;
		overflow: hidden;
		text-overflow: clip;
		white-space: pre;
		word-break: keep-all;
		pointer-events: none;
		line-height: inherit;
	}
</style>